// CardRateQuery Card-style Rate Query Module Internationalization - English
export default {
  // Search form
  searchForm: {
    departurePort: 'Departure Port',
    departurePortPlaceholder: 'Select departure port',
    dischargePort: 'Discharge Port',
    dischargePortPlaceholder: 'Select discharge port',
    originCountry: 'Origin Country',
    originCountryPlaceholder: 'Select origin country',
    originCity: 'Origin City',
    originCityPlaceholder: 'Select origin city',
    destinationCountry: 'Destination Country',
    destinationCountryPlaceholder: 'Select destination country',
    destinationCity: 'Destination City',
    destinationCityPlaceholder: 'Select destination city',
    cargoReadyTime: 'Cargo Ready Time',
    cargoTimeMode: {
      range: 'Range',
      date: 'Date'
    },
    cargoTimeRange: {
      threeDays: 'Within 3 days',
      oneWeek: 'Within 1 week',
      twoWeeks: 'Within 2 weeks',
      oneMonth: 'Within 1 month',
      twoMonths: 'Within 2 months'
    },
    cargoDatePlaceholder: 'Select cargo ready time',
    search: 'Search',
    reset: 'Reset',
    recentSearches: 'Recent Searches',
    filterSettings: 'Filter Settings',
    filterSettingsTitle: 'Configure Filter Conditions',
    filterSettingsOkText: 'OK',
    filterSettingsCancelText: 'Cancel',
    filterSettingsAvailable: 'Available Conditions',
    filterSettingsAllAdded: 'All conditions have been added',
    filterSettingsAdd: 'Add',
    filterSettingsSelected: 'Selected Conditions',
    filterSettingsEmpty: 'No filter conditions selected',
    moreFilters: 'More Filters'
  },

  // Toolbar
  toolbar: {
    containerType: 'Container Type',
    containerTypePlaceholder: 'Select container type',
    shippingCompany: 'Shipping Company',
    shippingCompanyPlaceholder: 'Select shipping company',
    transitType: {
      all: 'All',
      direct: 'Direct',
      transit: 'Transit'
    },
    sorting: {
      earliest: 'Earliest',
      fastest: 'Fastest',
      cheapest: 'Cheapest'
    },
    columnSettings: 'Column Settings'
  },

  // Column settings modal
  columnSettings: {
    confirm: 'OK',
    cancel: 'Cancel',
    availableFields: 'Available Fields',
    allFieldsAdded: 'All fields have been added',
    add: 'Add',
    selectedFields: 'Selected Fields',
    noFieldsSelected: 'No fields selected'
  },

  // Loading states
  loading: {
    searching: 'Loading...',
    loadingMore: 'Loading more data...',
    failed: 'Loading failed, please try again later',
    retry: 'Retry',
    noMoreData: 'All data loaded (Total {count} records)',
    scrollToLoadMore: 'Scroll to bottom to load more',
    scrollHint: 'Scroll down to load more'
  },

  // Empty state
  empty: {
    noData: 'No data available, please adjust search criteria and try again'
  },

  // FCL Rate Card
  fclCard: {
    freightType: {
      contract: 'Contract',
      spot: 'SPOT'
    },
    transitStatus: {
      direct: 'Direct',
      transit: 'Transit'
    },
    spaceStatus: {
      smooth: 'Smooth',
      singleApply: 'Single Apply',
      overbooked: 'Overbooked',
      notAccepting: 'Not Accepting'
    },
    priceTrend: {
      rising: 'Rising',
      falling: 'Falling',
      stable: 'Stable'
    },
    transitDays: '{days} days',
    priceUnit: '¥',
    headers: {
      carrier: 'Carrier',
      route: 'POL / POD',
      remarks: 'Remarks',
      validity: 'Validity',
      costTotal: 'Cost Total',
      sellTotal: 'Sell Total',
      inquiryTotal: 'Inquiry Total',
      actions: 'Actions'
    },
    route: {
      placeOfReceipt: 'POR',
      placeOfDelivery: 'Destination'
    },
    dataSource: {
      ecommerce: 'E-commerce',
      offline: 'Offline',
      cargoware: 'CargoWare'
    },
    shelf: {
      listed: 'Listed',
      unlisted: 'Unlisted'
    },
    recommend: {
      ecommerce: 'E-commerce Rate'
    },
    laneCode: 'Lane: {code}',
    cargoName: 'Cargo: {name}',
    remarks: {
      receivingInstructions: 'Receiving notes: ',
      overweight: 'Overweight notes: ',
      freePeriod: 'Free days: ',
      detentionFree: 'POD free detention {days} days',
      demurrageFree: 'POD free demurrage {days} days',
      note: 'Remarks: ',
      viewMore: 'View more'
    },
    cargo: {
      type: 'Cargo Type',
      description: 'Cargo Description'
    },
    selectedSailings: '✓ {count} sailing(s) selected',
    rateOnly: 'Rate only',
    actions: {
      viewDetail: 'View Details',
      costDetails: 'Fee Details',
      bookingNow: 'Book Now',
      viewTrend: 'View Trend',
      viewSailings: 'View Sailings',
      viewAvailableSailings: 'View Available Sailings'
    },
    tooltips: {
      transitRoute: 'Transit route: {route}'
    },
    fields: {
      detentionFreeDays: 'Free Detention Days',
      demurrageFreeDays: 'Free Demurrage Days'
    },
    periodTo: 'Until {end}',
    periodFrom: 'From {begin}'
  },

  // List/card schedule expand panel
  schedulePanel: {
    empty: 'No matching sailings',
    moreSchedules: 'More Schedules',
    placeOrder: 'Book',
    oceanFreight: 'Ocean Freight',
    columns: {
      vessel: 'Vessel',
      voyage: 'Voyage',
      laneCode: 'Lane Code',
      svcInfo: 'SVC Info',
      svc: 'SVC',
      directTransit: 'Direct/Transit',
      direct: 'Direct',
      transitPort: 'Transit Port',
      transit: 'Transit',
      firstSvc: 'First-leg SVC',
      secondSvc: 'Second-leg SVC',
      thirdSvc: 'Third-leg SVC',
      fourthSvc: 'Fourth-leg SVC',
      svcLeg: '{leg}-leg SVC',
      shareCabins: 'Shared Cabins',
      etd: 'ETD',
      eta: 'ETA',
      departureSchedule: 'Sailing Day',
      customsCutoffSchedule: 'Cutoff Day',
      portCutoffTime: 'CY Close',
      customsCutoffTime: 'Customs Cutoff',
      declarationDeadline: 'Declaration Deadline',
      action: 'Action'
    }
  },

  // LCL rate card
  lclCard: {
    cbmPrice: 'CBM Rate',
    tonPrice: 'TON Rate',
    minCharge: 'Min. Charge',
    cbmUnit: '/CBM',
    tonUnit: '/TON',
    minChargeUnit: '/B/L',
    actions: {
      viewSailings: 'Sailings',
      bookingNow: 'Book Online',
      viewDetail: 'Details'
    },
    fields: {
      laneCode: 'Lane Code'
    },
    selectedSailings: '{count} sailing(s) selected',
    scheduleNeedPorts: 'POL and POD are required to view sailings',
    scheduleLoadFailed: 'Failed to load sailings',
    validFrom: 'From {date}',
    validUntil: 'Until {date}'
  },

  // Air rate card
  airCard: {
    nPrice: 'N Rate',
    minPrice: 'Min. Charge',
    kgUnit: '/KG',
    perShipment: '/shipment',
    tierM: 'M (Min)',
    tierN: 'N',
    tier45: '45+',
    tier100: '100+',
    tier300: '300+',
    tier500: '500+',
    tier700: '700+',
    tier1000: '1000+',
    tier2000: '2000+',
    supplier: 'Supplier',
    airline: 'Airline',
    validPeriod: 'Validity',
    remarks: 'Remarks',
    directFlight: 'Direct',
    transitFlight: 'Transit',
    voyageDays: '{days}d',
    actions: {
      viewDetail: 'Details',
      bookingNow: 'Book Online'
    },
    validFrom: 'From {date}',
    validUntil: 'Until {date}',
    flightQueryPending: 'Flight query is under development...'
  },

  // Precarriage Card
  precarriageCard: {
    supplier: 'Supplier',
    priceMethod: {
      perContainer: 'Per Container',
      perTon: 'Per Ton',
      perCbm: 'Per CBM',
      direct: 'Direct',
      branchLine: 'Branch Line',
      seaRail: 'Sea-Rail'
    },
    transportMode: {
      truck: 'Truck',
      barge: 'Barge',
      rail: 'Rail'
    },
    status: {
      normal: 'Normal',
      expired: 'Expired',
      disabled: 'Disabled'
    },
    transitDays: '{days} days',
    priceUnit: '¥',
    costPrice: 'Cost',
    actions: {
      viewDetail: 'View Details',
      bookingNow: 'Book Now'
    },
    periodTo: 'Until {end}',
    periodFrom: 'From {begin}'
  },

  // Oncarriage Card
  oncarriageCard: {
    agent: 'Agent',
    address: 'Address',
    priceMethod: {
      perContainer: 'Per Container',
      perTon: 'Per Ton',
      perCbm: 'Per CBM',
      direct: 'Direct',
      branchLine: 'Branch Line',
      seaRail: 'Sea-Rail'
    },
    branchLine: {
      rail: 'Rail Branch',
      truck: 'Truck Branch',
      barge: 'Barge Branch'
    },
    status: {
      normal: 'Normal',
      expired: 'Expired',
      disabled: 'Disabled'
    },
    transitDays: '{days} days',
    priceUnit: '$',
    actions: {
      viewDetail: 'View Details',
      bookingNow: 'Book Now'
    },
    addressFormat: {
      city: '{city}',
      stateCity: '{state}, {city}',
      fullAddress: '{address}'
    },
    periodTo: 'Until {end}',
    periodFrom: 'From {begin}'
  },

  // Express rate card
  expressCard: {
    firstWeight: 'First {kg}kg',
    additionalWeight: 'Additional /{kg}kg',
    minimum: 'Min {currency} {amount}',
    tierFrom: 'From {kg}kg',
    tierCount: '{count} tiers',
    surchargeCount: '{count} surcharge(s)',
    billingMode: {
      percentage: 'Percentage',
      fixed: 'Fixed'
    },
    totalPerKg: 'Total/kg',
    formulaTitle: 'Total pricing formula',
    stepChargeableWeight: '1. Chargeable weight',
    chargeableWeightFormula: 'Chargeable wt = MAX(actual wt, volumetric wt)',
    volumetricWeightFormula: 'Volumetric wt = L×W×H÷6000',
    stepFormula: '2. Formula',
    formulaFirstAdditional:
      'Total = ((first weight + additional weight + peak surcharge) × KG + other fees) × (1 + fuel surcharge)',
    formulaUnitPrice:
      'Total = ((unit price + peak surcharge) × KG + other fees) × (1 + fuel surcharge)',
    formulaWeightTier:
      'Total = ((tier price + peak surcharge) × KG + other fees) × (1 + fuel surcharge)',
    resultEquals: 'Result =',
    formulaNote: 'Total is calculated based on 1 kg',
    packaging: 'Packaging',
    volumetricFactor: 'Volumetric factor',
    validPeriod: 'Validity',
    expired: 'Expired',
    actions: {
      detail: 'Details',
      linkOrder: 'Link order'
    },
    source: {
      inquiry: 'From inquiry',
      bid: 'From bid',
      manual: 'Manual entry'
    },
    status: {
      normal: 'Normal',
      published: 'Normal',
      expired: 'Expired',
      disabled: 'Disabled',
      draft: 'Draft'
    },
    serviceType: {
      express: 'Express',
      standard: 'Standard',
      economy: 'Economy',
      priorityFreight: 'Priority Freight',
      economyFreight: 'Economy Freight',
      deferredFreight: 'Deferred Freight'
    },
    loadingMode: {
      express: 'Express',
      ltl: 'LTL',
      ftl: 'FTL'
    },
    billingModel: {
      firstAdditional: 'First + Additional',
      unitPrice: 'Unit Price',
      weightTier: 'Weight Tier'
    },
    packagingType: {
      envelope: 'Envelope',
      parcel: 'Parcel',
      package: 'Package'
    },
    periodTo: 'Until {end}',
    periodFrom: 'From {begin}'
  },

  railSearchForm: {
    departureStation: 'Departure Station',
    departureStationPlaceholder: 'Select departure station',
    arrivalStation: 'Arrival Station',
    arrivalStationPlaceholder: 'Select arrival station',
    railCompany: 'Rail Company',
    railCompanyPlaceholder: 'Select rail company',
    transportMode: 'Rate Type',
    transportModePlaceholder: 'Select rate type',
    transportModes: {
      container: 'Container',
      truck: 'Full Truck',
      bulk: 'Bulk Cargo'
    }
  },

  railCard: {
    transitDays: '{days} days',
    minPrice: 'Min {price}',
    actions: {
      viewDetail: 'View Details'
    },
    units: {
      tonKilometer: 'ton-km',
      tonKilometerMatch: 'ton/kilometer|ton/km|ton-km'
    },
    railCompanyCode: {
      cre: 'CRE',
      kts: 'KTS',
      rzd: 'RZD',
      hkt: 'China-Laos-Thailand',
      tsr: 'Trans-Siberian'
    },
    fields: {
      containerOwner: 'Container Owner',
      cargoType: 'Cargo Type',
      routeType: 'Route Type'
    },
    transportMode: {
      container: 'Container',
      truck: 'Full Truck',
      bulk: 'Bulk Cargo'
    },
    direction: {
      import: 'Import',
      export: 'Export',
      transit: 'Transit',
      outbound: 'Outbound',
      inbound: 'Inbound'
    },
    routeType: {
      direct: 'Direct',
      transfer: 'Transit',
      combined: 'Intermodal',
      middle: 'Middle Line',
      north: 'North Line',
      south: 'South Line',
      southeast: 'Southeast Asia',
      centralAsia: 'Central Asia'
    },
    directTransit: {
      direct: 'Direct',
      transit: 'Transit'
    },
    status: {
      published: 'Published',
      draft: 'Draft',
      expired: 'Expired',
      disabled: 'Disabled'
    },
    cargoType: {
      general: 'General Cargo',
      dangerous: 'Dangerous Goods',
      reefer: 'Reefer',
      vehicle: 'Vehicle'
    }
  },

  // Common
  common: {
    containerTypes: {
      '20GP': '20GP',
      '40GP': '40GP',
      '40HC': '40HC',
      '45HC': '45HC',
      '20NOR': '20NOR',
      '40NOR': '40NOR'
    },
    noPrice: 'Inquiry',
    priceNotAvailable: '-',
    imageError: 'Image load failed',
    voyageDays: '{days} days',
    inquiryRequired: 'Inquiry Required',
    actions: {
      applySpecialPrice: 'Apply Special Price',
      applySpecialPriceShort: 'Apply'
    },
    messages: {
      specialPriceApplyPending:
        'The special price application form will be connected in a later module.'
    },
    currency: {
      usd: '$',
      cny: '¥',
      eur: '€'
    }
  },

  specialPriceApply: {
    title: 'Apply Special Price',
    sections: {
      rateInfo: 'Rate Information',
      basicInfo: 'Basic Information',
      priceDetail: 'Fee Details',
      surchargeDetail: 'Surcharge Details',
      applicationInfo: 'Application Information'
    },
    rateTypes: {
      fcl: 'FCL',
      lcl: 'LCL',
      prePort: 'Pre-carriage',
      lastMile: 'On-carriage',
      air: 'Air',
      express: 'Express',
      rail: 'Rail'
    },
    lclDefaultItemName: 'LCL Freight',
    fields: {
      rateType: 'Rate Type',
      rateNo: 'Rate No.',
      validPeriod: 'Valid Period',
      origin: 'Origin',
      destination: 'Destination',
      carrier: 'Carrier',
      customer: 'Customer',
      cargoReadyDate: 'Cargo Ready Date',
      cargoType: 'Cargo Type',
      quantity: 'Quantity',
      volumeCbm: 'Volume (CBM)',
      weightTon: 'Weight (TON)',
      chargeableWeight: 'Chargeable Weight',
      densityLevel: 'Density Level',
      currentTier: 'Current Weight Tier',
      targetKgUnitPrice: 'Target KG Unit Price',
      targetMinCharge: 'Target Minimum Charge',
      containerQuantity: 'Quantity',
      specifySchedule: 'Specify Schedule',
      schedule: 'Select Schedule',
      vessel: 'Vessel',
      voyage: 'Voyage',
      laneCode: 'Lane Code',
      targetPrice: 'Target Price Details',
      currentPrice: 'Current',
      reason: 'Reason',
      remark: 'Remark'
    },
    columns: {
      feeName: 'Fee Item',
      feeType: 'Fee Type',
      densityLevel: 'Density Level',
      itemName: 'Item',
      currency: 'Currency',
      billingUnit: 'Billing Unit',
      unitPrice: 'Unit Price',
      minCharge: 'Minimum Charge',
      maxCharge: 'Maximum Charge',
      paymentTerm: 'Payment Term',
      remark: 'Remark',
      feeSource: 'Fee Source',
      originalUnitPrice: 'Original Unit Price',
      originalMinCharge: 'Original Minimum Charge',
      quantity: 'Quantity',
      targetUnitPrice: 'Target Unit Price',
      targetMinCharge: 'Target Minimum Charge',
      targetLclMinCharge: 'Target Minimum Charge'
    },
    fees: {
      oceanFreight: 'Ocean Freight',
      baseRate: 'Base Rate',
      oceanSurcharge: 'Ocean Surcharge',
      originSurcharge: 'Origin Surcharge',
      destinationSurcharge: 'Destination Surcharge'
    },
    units: {
      container: 'pcs'
    },
    placeholders: {
      customer: 'Select customer',
      cargoReadyDate: 'Select cargo ready date',
      cargoType: 'Select cargo type',
      schedule: 'Select vessel/voyage',
      quantity: 'Enter quantity',
      chargeableWeight: 'Enter chargeable weight',
      densityLevel: 'Select density level',
      targetUnitPrice: 'Enter target unit price',
      targetMinCharge: 'Enter target minimum charge',
      selectContainerQuantityFirst: 'Enter container quantity first',
      selectQuantityFirst: 'Enter quantity first',
      reason: 'Enter reason',
      remark: 'Enter remark'
    },
    paymentTerms: {
      prepaid: 'Prepaid',
      collect: 'Collect'
    },
    airFeeTypes: {
      origin: 'Origin Surcharge',
      destination: 'Destination Surcharge',
      mainline: 'Mainline Surcharge'
    },
    feeSources: {
      manual: 'User Created',
      system: 'System Matched'
    },
    validation: {
      customerRequired: 'Please select customer',
      cargoReadyDateRequired: 'Please select cargo ready date',
      cargoReadyDateFuture: 'Cargo ready date must be later than today',
      cargoTypeRequired: 'Please select cargo type',
      reasonRequired: 'Please enter reason',
      reasonTooLong: 'Reason cannot exceed 500 characters',
      remarkTooLong: 'Remark cannot exceed 200 characters',
      priceItemRequired: 'Please enter at least one target price item',
      priceItemIncomplete: 'Quantity and target unit price must both be greater than 0',
      lclPriceItemIncomplete:
        'Enter at least one CBM or TON quantity, the target unit price, and the target minimum charge',
      compositeQuantityRequired:
        'Enter volume or weight and provide the quantity required by the current billing unit',
      compositePriceAmbiguous:
        'This pre-carriage or on-carriage rate has multiple billing units or currencies and cannot use one target price',
      targetPriceMustBeLower:
        'The target unit price for {itemName} must be lower than the original price {originalUnitPrice}',
      targetMinChargeMustBeLower: 'Target minimum charge must be lower than the current minimum charge',
      currencyRequired: 'Target price item is missing currency and cannot be submitted',
      currencyNotFound:
        'Currency {currency} was not found in master data. Please maintain currency master data first',
      scheduleRequired: 'Please select schedule',
      rateUnavailable: 'This rate does not allow special price application'
    },
    schedule: {
      helper: 'If not specified, the rate default schedule will be used',
      enabled: 'Specified',
      disabled: 'Not specified',
      matching: 'Matching available schedules',
      noMatched: 'No available schedule matched',
      reload: 'Match again'
    },
    actions: {
      submit: 'Submit'
    },
    messages: {
      submitSuccess: 'Special price application submitted: {applicationNo}',
      rateDetailLoadFailed: 'Failed to load rate details. Please try again later.'
    }
  },

  specialPriceApproval: {
    title: 'Special Price BPM Approval',
    back: 'Back',
    empty: 'No special price application details',
    missingRequest: 'Missing valid application ID or BPM process instance ID',
    loadFailed: 'Failed to load special price approval details',
    noPriceItems: 'No target price items',
    emptyRateFees: 'No rate fee details',
    emptySurchargeFees: 'No surcharge fee details',
    customerProfile: {
      title: 'Customer Profile',
      partnerCustomer: 'Partner Customer',
      empty: 'No customer profile data',
      loadFailed: 'Failed to load customer profile',
      totalOrderCount: 'Historical Orders',
      recentSixMonthAmount: '6-Month Amount',
      paymentScore: 'Payment Credit Score',
      profitRate: 'Profit Margin',
      permissionVisible: '(permission required)',
      recentSpecialPriceApplications: '6-Month Special Requests',
      times: 'times',
      approvedTimes: '{count} approved',
      passRate: 'Pass Rate',
      historyRates: 'Historical Deal Rates',
      specialPriceHistory: 'Historical Special Requests',
      emptyHistoryRates: 'No historical deal rates',
      emptySpecialPriceHistory: 'No historical special requests',
      historyRatesLoadFailed: 'Failed to load historical deal rates',
      historyApplicationsLoadFailed: 'Failed to load historical special requests',
      viewAll: 'View All',
      totalRecords: '{count} records',
      historyRateDrawerTitle: 'Historical Deal Rates',
      historyApplicationDrawerTitle: 'Historical Special Requests',
      columns: {
        orderNo: 'Order No.',
        dealDate: 'Deal Date',
        applicationNo: 'Application No.',
        applicationDate: 'Application Date',
        route: 'Route',
        rateType: 'Rate Type',
        unitPrice: 'Unit Price',
        quantity: 'Quantity',
        amount: 'Tax-Inclusive Amount',
        unit: 'Billing Unit',
        targetAmount: 'Target Amount',
        status: 'Status'
      },
      statuses: {
        pendingApproval: 'Pending Approval',
        approved: 'Approved',
        rejected: 'Rejected',
        expired: 'Expired',
        ordered: 'Ordered'
      }
    },
    aiDecision: {
      title: 'AI Decision Support',
      unavailable: 'Decision support is temporarily unavailable',
      unavailableDesc:
        'Deviations and risk alerts will be shown after data sources are connected',
      loadFailed: 'Failed to load decision support',
      empty: 'No decision support data',
      verdictApprove: 'Approve Recommended',
      verdictConditional: 'Conditional Approval Recommended',
      verdictReject: 'Reject Recommended',
      creditScore: 'Customer Credit Score',
      scoreNoData: 'No Data',
      scoreExcellent: 'Excellent',
      scoreGood: 'Good',
      scoreAverage: 'Average',
      scoreAttention: 'Attention Required',
      priceDeviation: 'Price Deviation Analysis',
      currentRate: 'Current Rate',
      noCalculablePriceDeviation: 'Original rate is empty or zero, so deviation cannot be calculated',
      specialVsHistory: 'Special vs Original Rate',
      specialVsMarket: 'Special vs Market Quote',
      applicationSummary: 'Historical Request Summary',
      total: 'Total',
      passed: 'Passed',
      passRate: 'Pass Rate',
      riskWarnings: 'Risk Alerts',
      riskUnavailable: '3-month order cancellation rate is unavailable',
      noEffectiveOrders: 'No in-progress, completed, or cancelled orders in the last 3 months',
      noCancelledOrders: '{total} effective orders in the last 3 months, none cancelled',
      cancelledOrders:
        '{total} effective orders in the last 3 months, {cancelled} cancelled, cancellation rate {rate}',
      noRisk: 'No risk alerts',
      referenceOnly: 'Decision support data is for approval reference only. The approver makes the final decision.'
    },
    sections: {
      application: 'Application Information',
      applicationFilled: 'Application Information',
      applicationRemark: 'Application Remark',
      rate: 'Rate Information',
      basicInfo: 'Basic Information',
      routeInfo: 'Route Information',
      carrierInfo: 'Carrier Information',
      freePeriod: 'Free Period',
      validPeriod: 'Validity',
      remarkInfo: 'Remarks',
      rateFeeDetails: 'Rate Fee Details',
      surchargeDetails: 'Surcharge Details',
      schedule: 'Specified Schedule',
      quantity: 'Quantity',
      containerConfig: 'Container Configuration',
      lclPriceApplication: 'LCL Target Price Configuration',
      airPriceApplication: 'Air Target Price Configuration',
      price: 'Target Price Details'
    },
    fields: {
      applicationNo: 'Application No.',
      status: 'Status',
      customer: 'Customer',
      applicant: 'Applicant',
      cargoReadyDate: 'Cargo Ready Date',
      cargoType: 'Cargo Type',
      volumeCbm: 'Volume (CBM)',
      weightTon: 'Weight (TON)',
      specifySchedule: 'Specified Schedule',
      reason: 'Reason',
      remark: 'Remark',
      rejectedReason: 'Reject Reason',
      rateType: 'Rate Type',
      rateNo: 'Rate No.',
      validPeriod: 'Valid Period',
      spaceStatus: 'Space Status',
      priceTrend: 'Price Trend',
      carrier: 'Carrier',
      origin: 'Origin',
      destination: 'Destination',
      pol: 'POL',
      pod: 'POD',
      deliveryPlace: 'Place of Delivery',
      directTransit: 'Direct/Transit',
      supplier: 'Supplier',
      targetAmount: 'Application Amount',
      vessel: 'Vessel',
      voyage: 'Voyage',
      laneCode: 'Lane Code',
      schedule: 'Schedule',
      scheduleSource: 'Schedule Source',
      contractNo: 'Contract No.',
      detentionFreeDays: 'Free Detention (Days)',
      demurrageFreeDays: 'Free Demurrage (Days)',
      beginDate: 'Start Date',
      endDate: 'End Date',
      overweightRemarks: 'Overweight Remarks',
      receivingInstructions: 'Receiving Instructions',
      oceanFreight: 'Ocean Freight',
      baseRate: 'Base Rate'
    },
    columns: {
      itemName: 'Item',
      itemCode: 'Code',
      containerType: 'Container Type',
      volumeCbm: 'Volume (CBM)',
      weightTon: 'Weight (TON)',
      densityLevel: 'Density Level',
      pricingTier: 'Weight Tier',
      currency: 'Currency',
      billingUnit: 'Billing Unit',
      quantity: 'Quantity',
      originalUnitPrice: 'Original Unit Price',
      targetUnitPrice: 'Target Unit Price',
      targetContainerUnitPrice: 'Target Unit Price',
      targetMinCharge: 'Target Minimum Charge',
      targetLclMinCharge: 'Target Minimum Charge',
      minCharge: 'Minimum Charge',
      wmPrice: 'W/M Target Unit Price',
      decreaseRate: 'Decrease Rate',
      priceDelta: 'Difference / Discount',
      lineAmount: 'Subtotal',
      feeName: 'Fee Name',
      feeType: 'Fee Type',
      unit: 'Unit',
      unitPrice: 'Unit Price'
    },
    labels: {
      yes: 'Yes',
      no: 'No'
    },
    weekdays: {
      mon: 'Mon',
      tue: 'Tue',
      wed: 'Wed',
      thu: 'Thu',
      fri: 'Fri',
      sat: 'Sat',
      sun: 'Sun'
    },
    rateValues: {
      fclFreightType: {
        contract: 'Contract Rate',
        spot: 'SPOT E-commerce Rate',
        peer: 'Peer Rate'
      },
      lclRateType: {
        carrier: 'Carrier Rate',
        nvo: 'NVO Peer Rate',
        ecommerce: 'E-commerce Rate',
        supplier: 'Supplier Quote'
      },
      spaceStatus: {
        available: 'Available',
        normal: 'Normal',
        singleTicket: 'Single Ticket Apply',
        full: 'Full',
        rejected: 'Rejected'
      },
      priceTrend: {
        up: 'Price Up',
        down: 'Price Down',
        stable: 'Price Stable'
      },
      directTransit: {
        direct: 'Direct',
        transit: 'Transit',
        unspecified: 'Unspecified'
      }
    },
    actions: {
      approve: 'Approve',
      reject: 'Reject',
      retry: 'Retry'
    },
    status: {
      PENDING_APPROVAL: 'Pending Approval',
      APPROVED: 'Approved',
      REJECTED: 'Rejected',
      EXPIRED: 'Expired',
      ORDERED: 'Ordered'
    }
  },

  // Field labels
  fields: {
    validPeriod: 'Valid Period',
    etd: 'ETD',
    eta: 'ETA',
    voyage: 'Voyage',
    remarks: 'Remarks',
    postalCode: 'Postal Code',
    agent: 'Agent',
    supplier: 'Supplier',
    detailAddress: 'Detail Address',
    vesselVoyage: 'Vessel/Voyage',
    carrier: 'Carrier',
    freeDetentionDays: 'Free Detention Days',
    freeDemurrageDays: 'Free Demurrage Days',
    vesselSchedule: 'Vessel Schedule'
  },

  // Route related
  route: {
    directRoute: 'Direct Route',
    transitRoute: 'Transit Route',
    transitPorts: 'Transit Ports: {ports}',
    noRemarks: 'No remarks'
  },

  // Bulk cargo rate card
  bulkCard: {
    defaultCargoType: 'Bulk Cargo',
    supplierFallback: 'Bulk',
    unitPerTon: '/MT',
    voyageDays: '{days}d',
    direct: 'Direct',
    transit: 'Transit',
    space: 'Space',
    validity: 'Validity',
    periodTo: 'Until {end}',
    periodFrom: 'From {begin}',
    spaceStatus: {
      smooth: 'Open',
      normal: 'Normal',
      singleApply: 'Single apply',
      overbooked: 'Overbooked',
      notAccepting: 'Closed'
    }
  },

  // RoRo rate card
  roroCard: {
    defaultVehicleType: 'Vehicle',
    unitPerVehicle: '/unit',
    voyageDays: '{days}d',
    direct: 'Direct',
    transit: 'Transit',
    sailing: 'Sailing',
    validity: 'Validity',
    space: 'Space',
    periodTo: 'Until {end}',
    periodFrom: 'From {begin}',
    spaceStatus: {
      smooth: 'Open',
      normal: 'Normal',
      singleApply: 'Single apply',
      overbooked: 'Overbooked',
      notAccepting: 'Closed'
    }
  },

  // Messages
  messages: {
    searchSuccess: 'Search successful',
    searchFailed: 'Search failed, please try again later',
    loadMoreSuccess: 'Load more successful',
    loadMoreFailed: 'Load more failed',
    noSearchCondition: 'Please enter search criteria',
    invalidDateRange: 'Invalid date range',
    saveSearchHistoryFailed: 'Failed to save search history',
    loadSearchHistoryFailed: 'Failed to load search history',
    getPortNameFailed: 'Failed to get port name',
    clickTabToLoad: 'Click {tab} tab to start loading data',
    portFallback: 'Port {id}',
    noRemarks: 'No remarks'
  },

  // Search Progress
  searchProgress: {
    searchingRates: 'Searching for rates...',
    collapse: 'Collapse',
    foundRates: 'Found {count} rates',
    estRemaining: 'Est. remaining: {time}s',
    waiting: 'Waiting',
    searching: 'Searching',
    completed: 'Completed',
    resultsCount: '{count} results',
    noData: 'No matching data',
    foundCount: 'Found {count}'
  }
}
